import { useEffect } from "react";

const SITE = "https://unimora.in";
const DEFAULT_TITLE = "Unimora AI — Dream · Decide · Achieve";
const DEFAULT_DESCRIPTION =
  "Unimora AI — AI-powered university decision intelligence helping ambitious students and families to make confident global university decisions.";

function setMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Per-page <title>, description, canonical URL and Open Graph tags (Geoify issues 11, 16, 17, 26).
 * `path` is the canonical path WITHOUT query string, e.g. "/compare" or "/universities/oxford".
 * Note: this runs in the browser, so Google (which renders JavaScript) sees it; AI crawlers that
 * read raw HTML only see the defaults in public/index.html until pages are prerendered.
 */
export default function usePageMeta({ title, description, path }) {
  useEffect(() => {
    const fullTitle = title ? `${title} · Unimora AI` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const url = SITE + (path || window.location.pathname);
    document.title = fullTitle;
    setMeta("name", "description", desc);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", desc);
    setMeta("property", "og:url", url);
    setCanonical(url);
  }, [title, description, path]);
}
